<template>
  <v-main id="MainTable" style="max-width: unset" class="pa-0 ma-0">
    <HeaderResale
      :arrow="false"
      title="Revendedores"
      text="Veja todos os revendedores, veja detalhes, desative revendedores e edite seus cadastros"
      :haveAction="true"
      @action="addResale"
      @action2="importExcel"
      @action3="copyLink"
    />

    <v-container
      style="max-width: unset; background: #e5e5e5"
      class="pa-6 pt-2"
    >
      <!-- Linha visivel filter -->
      <v-tabs
        v-model="tab"
        class="px-3"
        style="margin-top: 20px !important"
        background-color="#ECEEF1"
        grow
        height="55"
        hide-slider
      >
        <v-tab
          @click="filterSolicita('all')"
          href="#mobile-tabs-5-1"
          active-class="active-tab"
          class="tab"
        >
          <span>Revendedores</span>
          <span class="ma-3 px-3" style="color: black; max-width: 350px">
            ({{ countStatus }} Revendas)
          </span>
        </v-tab>
        <v-tab
          active-class="active-tab"
          class="tab"
          @click="filterSolicita('Inativo')"
          href="#mobile-tabs-5-2"
          :value="1"
        >
          <span>Solicitações</span>
          <span class="ma-3 px-3" style="color:red;max-width=350px">
            ({{ countStatusInativos }} pedidos)
          </span>
        </v-tab>
      </v-tabs>

      <v-card
        transition="scale-transition"
        v-if="showFilters"
        class="d-column mt-0 mb-6 pt-2 pb-0"
        elevation="0"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <!-- Primeira linha de filtro -->

        <v-row class="pt-7 pr-6 pl-2 pb-2">
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              v-model="filter.Name"
              class="filterAutocomplete"
              item-text="Name"
              label="Razão Social"
              prepend-inner-icon="mdi-magnify"
              attach
              dense
              outlined
              hide-no-data
              hide-details
              cache-items
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              class="filterAutocomplete"
              v-model="filter.Cnpj"
              attach
              color="secondary"
              dense
              outlined
              hide-details
              style="width: 100%"
              item-text="name"
              item-value="resaleType"
              required
              label="CNPJ"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              class="filterAutocomplete"
              v-model="filter.email"
              attach
              color="secondary"
              dense
              outlined
              hide-details
              style="width: 100%"
              item-text="email"
              item-value="resaleEmail"
              required
              label="E-mail"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <!-- <v-col
            class="d-flex flex-column align-start my-0 py-2"
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              v-model="filter.Id"
              class="filterAutocomplete"
              attach
              color="secondary"
              dense
              outlined
              style="width: 100%"
              item-text="name"
              item-value="id"
              required
              label="ID"
              hide-details
              :loading="loading"
            ></v-text-field>
          </v-col> -->

          <v-col
            class="d-flex flex-column align-start my-0 py-2"
            cols="12"
            md="2"
            sm="6"
          >
            <v-autocomplete
              v-model="filter.ResaleCategory"
              class="filterAutocomplete"
              attach
              color="secondary"
              dense
              outlined
              style="width: 100%"
              :items="categories"
              item-text="categories"
              item-value="categories"
              required
              label="Categoria"
              @change="filterTable"
              hide-details
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <!-- <v-col
            class="d-flex flex-column align-start my-0 py-2"
            cols="12"
            md="2"
            sm="6"
          >
            <v-autocomplete
              class="filterAutocomplete"
              :disabled="disableStatus"
              v-model="filter.Status"
              attach
              color="secondary"
              dense
              outlined
              style="width: 100%"
              :items="status"
              required
              label="Status"
              hide-details
              @change="filterTable"
              :loading="loading"
              item-text="label"
              item-value="value"
            ></v-autocomplete>
          </v-col> -->
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-autocomplete
              v-model="filter.order"
              class="filterAutocomplete"
              attach
              color="secondary"
              dense
              outlined
              style="width: 100%"
              :items="orders"
              item-text="text"
              item-value="value"
              label="Ordenar"
              @change="filterTable"
            >
            </v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-row align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="4"
          >
            <!-- <v-btn
            class="mx-2 hidden-sm-and-down"
            color="normaldark"
            style="border-radius: 10px"
            @click="showFilters ? (showFilters = false) : (showFilters = true)"
          >
            <v-icon v-if="!showFilters" class="pl-0">mdi-filter-menu </v-icon>
            <v-icon v-if="showFilters" class="pl-0">mdi-filter-off</v-icon>
            <span>Abrir todos os filtros</span>
          </v-btn> -->

            <!-- <v-btn
              class="mx-2 hidden-md-and-up"
              color="normaldark"
              style="border-radius: 10px"
              @click="
                showFilters ? (showFilters = false) : (showFilters = true)
              "
            >
              <v-icon v-if="!showFilters" class="pl-0">mdi-filter-menu </v-icon>
              <v-icon v-if="showFilters" class="pl-0">mdi-filter-off</v-icon>
            </v-btn> -->

            <v-btn
              class="mr-2"
              color="normaldark"
              elevation="2"
              style="
                border: 1px solid #bc0000;
                box-sizing: border-box;
                border-radius: 10px;
              "
              @click="reset"
              :loading="loading"
            >
              <v-icon class="pl-0">mdi-cached</v-icon>
              <span>Limpar</span>
            </v-btn>

            <!-- Export Excel -->
            <!-- <v-btn
              elevation="0"
              fab
              tile
              style="border-radius: 6px"
              small
              color="normaldark"
              @click="exportExcel"
            >
              <v-icon color="white">mdi-file-excel</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </v-card>

      <!-- Importar Excel -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="importDialog"
        max-width="650px"
      >
        <ImportExcel
          title="Importar Revendas"
          textMessage="Importar arquivos '.xlsx' (Excel) para agilizar o processo de adição de revendas em massa!"
          icone="mdi-arrow-down-circle"
          tipo="Revenda"
          route="resale"
          typeRoute="revendas"
          @close="(importDialog = false), updateTable()"
          @generate="(importDialog = false), updateTable()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- Exportar Excel -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="excelDialog"
        max-width="500px"
      >
        <ExcelModal
          title="Exportar Revendas"
          textMessage="Deseja exportar os revendedores para excel ?"
          cancelBtn="Cancelar"
          okbtn="Sim, exportar"
          icone="mdi-arrow-up-circle"
          textObservation=""
          @close="excelDialog = false"
          @generate="(excelDialog = false), generateExcel()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- Dialog DETAILS  -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="detailsDialog"
        max-width="900px"
      >
        <DetailsResale
          title="Detalhar Revenda"
          :resale="this.currentResale"
          @action="detailsDialog = false"
          @close="filterTable(), (detailsDialog = false)"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- Dialog DELETE  -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="deleteDialog"
        max-width="450px"
      >
        <DeleteModal
          title="Deletar"
          textMessage="Tem certeza que deseja deletar esta revenda?"
          cancelBtn="Cancelar"
          okbtn="Deletar"
          textObservation=""
          icone="mdi-restore-alert"
          @close="(deleteDialog = false), updateTable()"
          @action="(deleteDialog = false), remove()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- ChangeStatus Dialog  -->
      <v-dialog v-model="changeDialog" max-width="450px">
        <AprovalModal
          :title="
            currentResale.status === 1 ? 'Ativar Revenda' : 'Inativar Revenda'
          "
          :textMessage="aprovalConfirm"
          cancelBtn="Cancelar"
          :okbtn="currentResale.status === 1 ? 'ATIVAR' : 'INATIVAR'"
          textObservation=""
          icone="mdi-restore-alert"
          @close="(changeDialog = false), updateTable()"
          @action="(changeDialog = false), editStatus()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <v-dialog v-model="confirmActionDialog" max-width="450">
        <ConfirmModal
            v-if="actionSelected"
            title=""
            textMessage=""
            :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
            textObservation2=""
            cancelBtn="Cancelar"
            okbtn="Sim"
            textObservation=""
            @close="(confirmActionDialog = false)"
            @action="updateStatusResale()"
        />
      </v-dialog>

      <!-- Tabela -->
      <v-data-table
        ref="table"
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhuma revenda encontrada"
        class="elevation-0 mytable content-table"
        hide-default-footer
        :headers="headers"
        :items="resales"
        :items-per-page="pageSize"
        :header-props="headerProps"
        v-model="selectedResales"
        show-select
        item-key="id"
        :single-select="false"
      >
        <template v-slot:[`header.download`]="{ header }">
          <v-btn
            outlined
            tile
            icon
            v-on="header"
            class="quinary-button"
            style="border-radius: 5px"
            @click="exportExcel"
          >
            <v-icon>mdi-download-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.phoneNumber`]="{ item }">
          <span>
            {{ item.phoneNumber != null ? item.phoneNumber : "Sem registro" }}
          </span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-select
            class="ma-0 pa-0"
            style="width: 110px !important"
            dense
            hide-details
            outlined
            :items="status"
            @change="toggleChangeDialog(item)"
            item-text="label"
            item-value="value"
            v-model="item.status"
          >
            <template v-slot:selection="{ item }">
              <span class="normal">{{ item.label }}</span>
            </template>
          </v-select>
        </template>

        <template v-slot:[`item.reputationStars`]="{ item }">
          <v-rating
              v-model="item.reputationStars"
              bg-color="orange-lighten-1"
              color="normalred"
              clearable
              @input="changeFavorite(item)"
          ></v-rating>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-row style="flex-wrap: nowrap">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="76"
                  height="35"
                  small
                  class="quinary-button"
                  color="quaternary"
                  @click="goToProfile(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>Detalhar</span>
                </v-btn>
              </template>
              <span>Detalhar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="quinary-button ml-2"
                  color="quaternary"
                  @click="editResale(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="remove-button ml-2"
                  color="red"
                  @click="deleteResale(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </v-row>
        </template>

        <template v-slot:header.data-table-select="{ on, props}">
          <v-simple-checkbox
              color="#bc0000"
              v-bind="props"
              v-on="on"
              :ripple="false"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
          <v-simple-checkbox
              :ripple="false"
              @click="addResaleListSelectedResales(item)"
              :value="isSelected"
              color="#bc0000"
              v-bind="props"
              v-on="on"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:footer >
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>

          <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedResales.length > 0">
            <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <label>Selecione a ação</label>
              <v-select
                  class="ma-0 pa-0 "
                  dense
                  v-model="actionSelected"
                  outlined
                  style="border-radius: 3px!important"
                  :items="actions"
                  item-text="label"
                  item-value="value"
                  placeholder="Selecione a ação"
              >
              </v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
              <v-btn
                  class="secondary-button mt-5 ml-3"
                  style="height: 40px!important; border-radius: 7.5px!important"
                  height="40"
                  width="100%"
                  elevation="0"
                  :disabled="!actionSelected"
                  @click="confirmActionDialog = true"
              >
                {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>

      <!-- Paginação -->
      <div class="my-5 text-center d-flex align center justify-center">
        <v-pagination
          color="black"
          v-model="page"
          :length="totalPages"
          :total-visible="7"
          circle
        ></v-pagination>
      </div>
    </v-container>
  </v-main>
</template>

<style scoped>
.normal {
  font-style: normal;
  font-weight: 300;
  font-size: 15px !important;
  color: #979797;
}
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}
.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box !important;
  border-radius: 8px !important;
  width: 100% !important;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
}

.table-button:hover {
  background: #2d3038 !important ;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 1024px) {
  .mytable {
    max-width: 100%;
  }
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import DetailsResale from "./components/DetailsResale.vue";
import ExcelModal from "../components/ExcelModal.vue";
import ImportExcel from "../components/ImportExcel.vue";
import HeaderResale from "./components/HeaderResale.vue";
import AprovalModal from "../components/AprovalModal.vue";
import DeleteModal from "../components/DeleteModal.vue";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    ConfirmModal,
    Pagination,
    DetailsResale,
    HeaderResale,
    ImportExcel,
    ExcelModal,
    AprovalModal,
    DeleteModal,
  },

  data: () => ({
    selectedResales: [],
    actions: [
      { label: "Ativar revenda(s)", value: 1},
      { label: "Inativar revenda(s)", value: 2},
    ],
    actionSelected: null,
    confirmActionDialog: false,
    tab: 0,
    countStatusInativos: "",
    approveSelectedItem: null,
    countStatus: "",
    disableStatus: false,
    ativos: [],
    length: "",
    resalesId: "",
    showFilters: true,
    rating: "",
    dialog: false,
    closeNoLoading: false,
    addDialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    importDialog: false,
    detailsDialog: false,
    changeDialog: false,
    excelDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    resales: [],
    currentResale: {},
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 15,
    btnColor: "",
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
      DocumentNumber: null,
      Name: null,
      Cnpj: null,
      Id: null,
      Category: null,
      Status: null,
      updated_at: null,
      order: null,
    },
    orders: [
      {
        text: "Crescente cadastro",
        value: 0,
      },
      {
        text: "Decrescente cadastro",
        value: 1,
      },
    ],
    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    categories: ["Categoria 1", "Categoria 2", "Categoria 3", "Categoria 4"],
    error: false,
    show: false,
    message: "",
    headers: [
      {
        text: "Razão Social",
        align: "start",
        class: "item",
        value: "name",
        sortable: false,
      },
      {
        text: "Nome fantasia",
        align: "start",
        class: "item",
        value: "nameFantasy",
        sortable: false,
      },
      {
        text: "CNPJ/CPF",
        class: "item",
        value: "cnpj",
        align: "start",
        sortable: false,
      },
      {
        text: "Status",
        class: "item",
        value: "status",
        align: "start",
        sortable: false,
      },

      {
        text: "E-mail",
        class: "item",
        value: "email",
        align: "start",
        sortable: false,
      },
      {
        text: "Skus cadastrados",
        class: "item",
        value: "numberOfRegisteredSkus",
        align: "start",
        sortable: false,
      },
      {
        text: "Reputação",
        class: "item",
        value: "reputationStars",
        align: "start",
        sortable: false,
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    urlB2B: process.env.VUE_APP_BASE_URL_FRONT,
  }),

  computed: {
    aprovalConfirm() {
      return `Tem certeza que deseja ${
        this.currentResale.status == 1 ? "ativar" : "inativar"
      } a revenda ${this.currentResale.name} ?`;
    },
  },

  async created() {
    this.urlB2B = process.env.VUE_APP_BASE_URL_FRONT
    const jsonFilters = localStorage.getItem("resaleFilters");
    const jsonFilterTab = localStorage.getItem("resaleFiltersTab");

    if (jsonFilters) {
      this.filter = JSON.parse(jsonFilters);
      this.page = this.filter.page;
    }

    this.tab = jsonFilterTab ? JSON.parse(jsonFilterTab) : this.tab;

    await this.updatePageView();
  },

  methods: {
    changeFavorite(resale) {
      this.apiService
          .post("resale/changeReputation", resale)
          .then((response) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Não foi possível mudar a status da revenda",
              message: response.message,
              trace: null,
            });
          })
          .catch(() => {

          });
    },
    updateStatusResale(){
      try {
        this.confirmActionDialog = false;
        const selectedResales = JSON.parse(JSON.stringify(this.selectedResales))
        selectedResales.forEach((resale) => {
          resale.status = this.actionSelected === 1 ? 1 : 0;
        })

        this.apiService.post('resale/status/list', selectedResales).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Status das revendas atualizadas com sucesso",
            trace: null,
          });
          await this.updateTable()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível atualizar o status das revendas",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    addResaleListSelectedResales(resale){
      const resaleFind = this.selectedResales.findIndex((x) => x.id === resale.id)
      if (resaleFind > -1) {
        this.selectedResales.splice(resaleFind, 1)
      } else {
        this.selectedResales.push(resale)
      }
    },

    async goToProfile(item) {
      localStorage.setItem("resaleFilters", JSON.stringify(this.filter));
      localStorage.setItem("resaleFiltersTab", JSON.stringify(this.tab));

      await this.$router.push({
        path: `/profile-resales?id=` + item.id,
        params: item,
      });
    },

    async updatePageView() {
      this.filter.Status = null;
      await this.updateTable();
    },

    filterSolicita(arg) {
      this.filter.pageSize = this.pageSize;
      this.page = 1;
      this.filter.page = this.page;
      if (arg == "Inativo") {
        this.disableStatus = true;
        this.filter.Status = 0;
      } else if (arg == "all") {
        this.disableStatus = false;
        this.filter.Status = null;
      }
      this.updateTable();
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    async generatePDF(resale) {
      this.apiService
        .get(`resale/generate/pdf/${resale.id}`)
        .then((resp) => {
          resp = "data:application/pdf;base64," + resp;
          const link = document.createElement("a");
          link.href = resp;
          link.setAttribute(
            "download",
            "Revenda: " + resale.Name + " " + this.formatDate(new Date())
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {});
    },

    toggleChangeDialog(item) {
      this.approveSelectedItem = item;
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
    },

    async editResale(item) {
      localStorage.setItem("resaleFilters", JSON.stringify(this.filter));
      localStorage.setItem("resaleFiltersTab", JSON.stringify(this.tab));
      await this.$router.push({
        path: "/add-resales?isEditing=true&id=" + item.id,
        params: item,
      });
    },

    async editStatus() {
      this.loading = true;
      await this.apiService
        .post(`resale/changestatus`, this.approveSelectedItem)
        .then((resp) => {
          this.updatePageView();
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Mudança de status efetuada!",
            message: "Mudança de status efetuada!",
            trace: null,
          });
        })
        .catch((err) => {
          if (err.status !== 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível mudar a status da revenda",
              message: err.body.message,
              trace: null,
            });
          } else if (err.status === 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Este usuário não tem autorização para concluir a ação.",
              message:
                "Somente usuários com permissão podem deletar/editar revendas",
              trace: null,
            });
            this.$router.push("/resales");
            this.close();
          }
          this.updatePageView();
          this.loading = false;
        });
    },

    async addResale(item) {
      await this.$router.push({
        path: "/add-resales",
      });
    },

    deleteResale(resale) {
      this.currentResale = resale;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    exportExcel(resales) {
      this.currentResale = resales;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },

    detailsResale(resale) {
      this.currentResale = resale;
      this.dialogKey = !this.dialogKey;
      this.detailsDialog = true;
    },

    importExcel(resales) {
      this.dialogKey = !this.dialogKey;
      this.importDialog = true;
    },

    async copyLink() {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard
            .writeText(`${this.urlB2B}revendedor-cadastro`)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Url copiada.",
                trace: null,
              });
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível copiar url",
                trace: null,
              });
            });
      }
    },

    closeDialog() {
      this.dialog = false;
      this.editDialog = false;
      this.deleteDialog = false;
      this.importDialog = false;
      this.detailsDialog = false;
      this.dialogKey = !this.dialogKey;
      this.updateTable();
    },

    openAbout(resale) {
      this.currentResale = resale;
      this.$router.push("/details-resales");
    },

    async filterTable() {
      this.loading = true;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      if (this.filter.Status == "Inativo") {
        this.filter.Status = 0;
      } else if (this.filter.Status == "Ativo") {
        this.filter.Status = 1;
      } else {
        this.filter.Status = null;
      }

      if (this.resaleInicialDate > this.resaleFinalDate) {
        this.error = true;
        this.reset();
        setTimeout(() => {
          this.error = false;
        }, 4000);
        return;
      }
      this.filter.birthDate = this.resaleInicialDate;
      this.filter.updated_at = this.resaleFinalDate;

      await this.updateTable();
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService
        .post(`resale/list`, this.filter)
        .then((response) => {
          this.totalPages = response.content.content.pager.totalPages;
          this.totalItems = response.content.content.pager.totalItems;
          this.currentPage = response.content.content.pager.currentPage;
          this.resales = response.content.content.resales;
          this.countStatusInativos = response.content.inactiveCount;
          this.countStatus = response.content.totalCount;

          this.loading = false;
          this.isLoading = false;
        })
        .catch(() => {
          this.loading = false;
          this.isLoading = false;
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    reset() {
      (this.filter = ""),
        (this.filter = {
          page: 1,
          pageSize: 15,
        });
      this.page = 1;
      this.updateTable();
    },

    close() {
      // this.currentResale = "";
      this.$emit("close");
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`resale/delete`, this.currentResale)
        .then(() => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Revendedor excluido com sucesso!",
            message: "",
            trace: null,
          });

          this.updateTable();
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.status != 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possivel remover este item.",
              message: err.body.message,
              trace: null,
            });
          } else if (err.status == 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Este usuário não tem autorização para concluir a ação.",
              message: "Somente usuários Master podem deletar/Editar revendas",
              trace: null,
            });
            this.$router.push("/resales");
            this.close();
          }

          this.loading = false;
        });
    },

    async generateExcel() {
      this.loading = true;

      let now = new Date();
      var filename =
        `Revendedores_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("resale/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          // this.$emit("close");
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: erro.body.message,
            trace: null,
          });
        });
      this.loading = false;
    },
  },

  watch: {},
};
</script>
